import { POSTGRES_CODES } from "src/lib/errors/postgresCodes";
import type { FeatureErrorMapper } from "src/lib/errors/types";

export const locationErrorMapper: FeatureErrorMapper = (action, err) => {
  if (
    action === "delete" &&
    err.code === POSTGRES_CODES.FOREIGN_KEY_VIOLATION
  ) {
    return "Cannot delete this location — it still holds inventory or sub-locations.";
  }

  if (err.code === POSTGRES_CODES.UNIQUE_VIOLATION) {
    return "A location with this name already exists.";
  }

  return null;
};
